import { createRoot } from "react-dom/client";
import "./lib/page-title";
import App from "./App.tsx";
import { installStaleBundleGuard } from "./lib/stale-bundle";
import "./index.css";

// A tab still on the bundle of before a deploy: reload once when one of its chunks no longer loads.
installStaleBundleGuard();

createRoot(document.getElementById("root")!).render(<App />);
